import { RefObject, useEffect, useState } from 'react'

interface ElementSizeProps {
  elementWidth?: number
  elementHeight?: number
}

export const useElementResize = (ref: RefObject<HTMLElement>) => {
  const [size, setSize] = useState<ElementSizeProps>({ elementWidth: undefined, elementHeight: undefined })

  useEffect(() => {
    if (ref.current) {
      const element = ref.current

      const handleResize = (entries: { contentRect: { width: number; height: number } }[]) => {
        const entry = entries[entries.length - 1]
        setSize({
          elementWidth: entry.contentRect.width,
          elementHeight: entry.contentRect.height,
        })
      }

      const observer = new ResizeObserver(handleResize)

      observer.observe(element)

      return () => observer.disconnect()
    }

    return undefined
  }, [ref.current])

  return size
}
